import urlcat from 'urlcat';

import { SearchParamKnownKeys } from 'src/hooks/useUrlSearchParams';

import getJobDetailsUrl, { JobDetailsTabs } from './getJobDetailsUrl';

export enum JobStageTab {
  GENERAL = 'general',
  INTERVIEW_PLAN = 'interview-plan',
  COMMUNICATIONS = 'communications',
  REQUESTS = 'requests',
}

export enum LinkTargets {
  interviewPlanSection = 'interviewPlanSection',
  availabilityJobStagRequestSection = 'availabilityJobStagRequestSection',
  selfScheduleJobStageRequestSection = 'selfScheduleJobStageRequestSection',
  scheduleLocationSection = 'scheduleLocationSection',
  candidateCommunicationJobStageSection = 'communicationJobStageCandidateSection',
  internalCommunicationJobStageSection = 'internalCommunicationJobStageSection',
  jobStageSelectSection = 'jobStageSelectSection',
}

export type JobStageSubMenuUrlType = `/jobs/${string}/job_stage/${string}/?nav=${JobStageTab}`;

export const getJobStageSubMenuUrl = ({
  jobId,
  jobStageId,
  tab,
  extraParams,
}: {
  jobId: string;
  jobStageId: string;
  tab: JobStageTab;
  extraParams?: { [key in SearchParamKnownKeys]?: string };
}): JobStageSubMenuUrlType => {
  return urlcat('', getJobDetailsUrl(jobId, JobDetailsTabs.JobStage, jobStageId), {
    [SearchParamKnownKeys.jobStageTabNav]: tab,
    ...extraParams,
  }) as JobStageSubMenuUrlType;
};
